import { UseMutationOptions, useMutation } from "@tanstack/react-query";
import { FieldValues } from "react-hook-form";
import axiosAuth from "../../axiosAuth";
import { BOM_USERS_API } from "../apiRoutes";

const mutateAssignBulkBomUser = async ({ data }: { data: FieldValues }) => {
  return await axiosAuth.post(`${BOM_USERS_API}/bulk`, data);
};

const useAssignBulkBomUserMutation = (
  queryParams?: UseMutationOptions<
    any,
    Error,
    {
      data: FieldValues;
    },
    unknown
  >
) =>
  useMutation({
    mutationFn: mutateAssignBulkBomUser,
    ...queryParams,
  });

export default useAssignBulkBomUserMutation;
